import { render, staticRenderFns } from "./PackageReceiveView.vue?vue&type=template&id=39eeb001&lang=pug"
import script from "./PackageReceiveView.vue?vue&type=script&lang=js"
export * from "./PackageReceiveView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports